import { post, get } from '../../../../services/request';

// Get all site list (with filters) - following RAD pattern
export const getAllSiteList = (filters) => {
    return post('SiteManagement/GetAllSiteList', {
        IsOffBoardingSites: filters.IsOffBoardingSites || false,
        PracticeIds: filters.PracticeIds || '',
        SiteActiveFrom: filters.SiteActiveFrom || '',
        SiteName: filters.SiteName || '',
        SiteStatus: filters.SiteStatus || null,
    });
};

// Get Practice Dropdown Data
export const getPracticeDropdownData = () => {
    return get('Common/GetPractices');
};

// Get Site Dropdown Data
export const getSiteDropdownData = () => {
    return get('SiteManagement/GetSiteAllDDList');
};

// Get Sub Practice Dropdown Data
export const getSubPracticeDropdownData = () => {
    return get('Common/GetSubPracticesWithGroupByPractice');
};

// Save Bulk Practice Site Data
export const saveBulkPracticeSiteData = (payload) => {
    return post('SiteManagement/SaveBulkPracticeSite', payload);
};

